export default __webpack_public_path__ + "assets/images/8eff27aa4411b0bbbcbcb55ec862cd5d.jpg";